function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgDragIndicator = function SvgDragIndicator(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20"
  }, props), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 17846",
    d: "M14.667 7.333A1.667 1.667 0 1 0 13 5.667a1.672 1.672 0 0 0 1.667 1.666Zm0 1.667a1.667 1.667 0 1 0 1.667 1.667A1.672 1.672 0 0 0 14.667 9Zm0 5a1.667 1.667 0 1 0 1.667 1.667A1.672 1.672 0 0 0 14.667 14Z",
    transform: "translate(-4.667 -.667)",
    style: {
      fill: "currentColor"
    }
  }));
};

export default SvgDragIndicator;